import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from '../../prop-types/intl';

export const ShippingServiceGroupPropType = PropTypes.shape({
  groupId: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, MessageDescriptorPropType]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      disabled: PropTypes.bool,
      selected: PropTypes.bool,
    }),
  ),
});
